module.exports = __webpack_public_path__ + "img/3c42a06.png";